import moment from 'moment';

export const formatDateTime = (dateString) => {
  return moment(dateString).format('M/D HH:mm');
};

export const formatTimeRange = (beginAt, endAt) => {
  const begin = moment(beginAt).format('M/D HH:mm');
  const end = moment(endAt).format('HH:mm');
  return `${begin}~${end}`;
};
